'use client';

import { useEffect } from 'react';

import { useOpenPaymentsAvailability } from '@/hooks/use-open-payments-availability.hook';
import { loadOpenPayments, resetOpenPayments } from '@/store/open-payments/open-payments.store';

export default function LoadOpenPaymentsComponent(): React.ReactNode {
  const { isAvailable, isResolved } = useOpenPaymentsAvailability();

  useEffect(() => {
    if (!isResolved) {
      return;
    }

    if (!isAvailable) {
      resetOpenPayments();
      return;
    }

    void loadOpenPayments();
  }, [isAvailable, isResolved]);

  return null;
}
